import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';

/**
 * Hook to check various admin access levels
 * Consolidates permission and role checks for admin features
 */
export const useAdminAccess = () => {
  const { user } = useAuth();
  const { can, canAny, loading } = usePermissions();

  const isSuperAdmin = user?.profile?.is_super_admin || false;
  const isOrganizationAdmin = user?.isOrganizationAdmin || false;
  
  // Admin-level checks (any admin role)
  const isAdmin = canAny([
    { resource: 'users', action: 'manage' },
    { resource: 'organization', action: 'manage' }
  ]);

  // Specific feature access
  const canManageUsers = can('users', 'manage') || can('users', 'invite');
  const canManageSysco = can('sysco', 'manage');
  const canViewReports = can('reports', 'view');
  const canManageOrganization = can('organization', 'manage');
  const canManageBilling = can('billing', 'manage');
  
  // Support access
  const canViewAllTickets = isSuperAdmin;
  const canManageTickets = isSuperAdmin || can('support', 'manage');

  return {
    // Role flags
    isSuperAdmin,
    isOrganizationAdmin,
    isAdmin,
    
    // Feature permissions
    canManageUsers,
    canManageSysco,
    canViewReports,
    canManageOrganization,
    canManageBilling,
    canViewAllTickets,
    canManageTickets,
    
    // Loading state
    loading,
    
    // Raw permission checker
    can,
    canAny,
  };
};
